<script setup>
import { ref, watch } from 'vue'
import { useLangStore } from '@/stores/app/lang'

const langStore = useLangStore()
const { changeLang } = useLangStore()

// State -----------------------------------------
const lang = ref(langStore.lang)

// Getters ---------------------------------------

// Methods ---------------------------------------

// Events ----------------------------------------
langStore.$subscribe((mutation, state) => {
  console.log('[LangTransition] $subscribe ->', { ...state })
  lang.value = state.lang
})
// -----------------------------------------------
</script>

<template>
  <transition name="fade" mode="out-in">
    <div class="lang" :lang="lang" :key="lang">
      <button v-if="lang == 'th'" @click="changeLang('en')">ภาษาไทย</button>
      <button v-else-if="lang == 'en'" @click="changeLang('th')">English</button>
    </div>
  </transition>
</template>

<style scoped>
.lang {
  text-align: center;  
}
</style>
